import { render, staticRenderFns } from "./Whatsappv1BotStateChanged.vue?vue&type=template&id=5978d858&scoped=true"
import script from "./Whatsappv1BotStateChanged.vue?vue&type=script&lang=js"
export * from "./Whatsappv1BotStateChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978d858",
  null
  
)

export default component.exports